class ProductCardForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const form = this.querySelector("form");
    if (!form) {
      return;
    }

    form.addEventListener("change", (event) => {
      const target = event.target;
      if (target.tagName !== "INPUT" || target.type !== "radio") {
        return;
      }

      const variantId = target.dataset.variantId;
      if (!variantId) {
        return;
      }

      const data = new FormData(form);
      data.set("id", variantId);

      fetch("/cart/add.js", {
        method: "POST",
        body: data
      })
        .then((res) => res.json())
        .then((response) => {
          document.dispatchEvent(new CustomEvent("addtocart", { detail: response }));
        })
        .catch((error) => {
          console.error("ProductCardForm: add to cart failed", error);
        });
    });
  }
}

customElements.define("product-card-form", ProductCardForm);